import { render, staticRenderFns } from "./CheckpointResultScene.vue?vue&type=template&id=6cfa864a&scoped=true&"
import script from "./CheckpointResultScene.vue?vue&type=script&lang=js&"
export * from "./CheckpointResultScene.vue?vue&type=script&lang=js&"
import style0 from "./CheckpointResultScene.vue?vue&type=style&index=0&id=6cfa864a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfa864a",
  null
  
)

export default component.exports